export const page = {
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'website',
      pt3: 'volledig afgestemd op jouw restaurant'
    },
    description: 'De website van Bistroo biedt de tools om een volledige conversie-verhogende landingspagina te creëren die de bestelervaring van je klanten van begin tot eind verbetert.',
    button: 'Maak je website'
  },
  paragraphs: {
    paragraph_1: {
      title: 'Eenvoudig te bouwen, moeiteloos te onderhouden',
      text: 'De website wordt gegenereerd op basis van de informatie van je restaurant en is eenvoudig aan te passen om perfect bij de stijl en branding van jouw restaurant aan te sluiten.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_2: {
      title: 'Automatisch geupdate',
      text: 'Alle wijzigingen die je aanbrengt in de Bistroo Manager worden direct doorgevoerd op je website, zodat je geen informatie handmatig hoeft bij te werken op meerdere editors of locaties.',
      cta: ''
    },
    paragraph_3: {
      title: 'Bied een uitstekende klantervaring',
      text: 'Van de eerste klik tot de betaling, jouw klanten genieten van een goed ontworpen bestelervaring die bijdraagt aan elke stap. Wat zowel de klantervaring als de reputatie van jouw restaurant versterkt.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_4: {
      title: 'Geoptimaliseerd voor online gebruik en e-commerce',
      text: 'Onze landingspagina\'s zijn ontworpen en gebouwd voor optimale SEO. Bereik de top van de organische zoekresultaten in jouw regio of geef je website een boost met kostenefficiënte advertenties.',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Zet je bestsellers in de spotlight.',
        text: 'Je menu-aanpassingen en best verkochte items zijn naadloos verbonden met je website, geen extra werk nodig. ',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Integraties.',
        text: 'Koppel je favoriete POS-systeem of externe tools.',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Presenteer en deel belangrijke informatie.',
        text: 'Communiceer belangrijke informatie duidelijk via je website door de instellingen in de Manager-app te wijzigen. ',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Contactformulieren.',
        text: 'Laat verzoeken toe via het geïntegreerde contactformulier.',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Geoptimaliseerd voor alle kanalen.',
        text: 'Alle websites zijn geoptimaliseerd voor Google Search én geschikt voor weergave op alle soorten apparaten.',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '"Bistroo bespaart ons dagelijks veel tijd en vermindert de frustratie bij klanten aanzienelijk."',
    cta: 'Lees volledig verhaal',
    name: 'Two-B by Mondie',
    job_title: 'Lunchroom'
  }
}
